import { useQuery } from "@tanstack/react-query";
import { getMessages, MESSAGES } from "../api/message-request";

type UseMessagesBySenderAndReceiverParams = {
  senderId: number;
  receiverId: number;
};

const messages = async (senderId: number, receiverId: number) => {
  const response = await getMessages(senderId, receiverId);
  return response.data;
};

export const useMessagesBySenderAndReceiver = ({
  senderId,
  receiverId,
}: UseMessagesBySenderAndReceiverParams) => {
  const { data, error, isLoading, isError } = useQuery({
    queryKey: [MESSAGES, senderId, receiverId],
    queryFn: () => messages(senderId, receiverId),
    refetchOnWindowFocus: false,
    staleTime: 0,
    retry: false,
  });

  return {
    messages: data,
    error,
    isLoading,
    isError,
  };
};
